module.exports = __webpack_public_path__ + "static/media/index-shop-4.35a988e7.webp";